import * as $ from 'jquery';
import * as _ from 'lodash';

/**
 * loading Animation
 */
class Loading {

    /* */
    private _isLoading: boolean;
    /* */
    private _count: number;

    /* フォーカスされた要素の保存*/
    private $actFoc;
    /*disabledされたボタンの保存*/
    private $actDis;


    /////////シングルトンパターン /////////
    // /**
    //  *  インスタンス
    //  */
    // private static _instance: Loading;

    // /**
    //  * インスタンスの取得
    //  */
    // public static getInstance(): Loading {
    //     // インスタンスが存在しない場合、new演算子でインスタンスを作成
    //     // 引数に渡すのは、Hoge.getInstanceというFunction
    //     if (!this._instance) {
    //         this._instance = new Loading(Loading.getInstance);
    //     }
    //     // 生成済みのインスタンスを返す
    //     return this._instance;
    // }

    // /**
    //  * コンストラクタ
    //  */
    // constructor(caller: Function) {
    //     if (caller == Loading.getInstance) {
    //         //console.log("2 インスタンスを作成。一度しか呼ばれない。");
    //         //} else if (Loading._instance) {
    //         //    throw new Error("既にインスタンスが存在するためエラー。");
    //         //} else {
    //         //    throw new Error("コンストラクタの引数が不正な為エラー。");
    //     }
    // }

    // //Usage
    // //let hoge1: Loading = Loading.getInstance();

    /////////シングルトンパターン /////////


    /**
     * ctor
     */
    constructor() {
        this._isLoading = false;
        this._count = 0;
        this.$actFoc = null;
        this.$actDis = null;
    }

    /**
      * Loading Animationを表示
      * @param backgroundColor
      */
    show(backgroundColor?: string) {

        if (!this.$actFoc || this.$actFoc.length === 0) {
            // 現在フォーカスが与えられている要素を取得し保存する
            this.$actFoc = $(':focus');
            // エンターキーで連打が可能なため、フォーカスをblurする
            this.$actFoc.blur();
        }

        // このeventによって、押した場所が特定できるので、chromeやie11でしか使えないが重要
        const e = /firefox/g.test(window.navigator.userAgent.toLowerCase()) ? undefined : event;

        if (e && this.$actDis === null) {
            // eventから現在押されたボタンを取得し保存する
            this.$actDis = $(e.target);
            //#4343 site.tsにて、別に2重送信防止機能があるので不要!!
            //// eventから現在押されたボタンをdisabledにする
            //this.$actDis.prop('disabled', true);
        }

        this._isLoading = true;
        //this._count += 1;
        this._count = this._count || 0;
        this._count += 1;

        //Loadingアイコンの作成
        if ((!$('#loadingIcon') || $('#loadingIcon').length === 0) && this._isLoading) {
            // フォーカスを制御
            $('a,button').on('focus.disabled', function (e) {
                // lodingアイコン中はfocusをblurする
                $(e.target).blur();
            });


            //
            //created by http://cssload.net/
            //

            let load = '<div class="loading-dots">';
            load += '  <div class="loading-dot"></div>';
            load += '  <div class="loading-dot"></div>';
            load += '  <div class="loading-dot"></div>';
            load += '  <div class="loading-dot"></div>';
            load += '  <div class="loading-dot"></div>';
            load += '</div>';
            load += '<svg version = "1.1" xmlns = "http://www.w3.org/2000/svg">';
            load += '  <defs>';
            load += '    <filter id = "goo"> ';
            load += '      <feGaussianBlur in="SourceGraphic" result = "blur" stdDeviation = "12" > </feGaussianBlur>';
            load += '      <feColorMatrix in="blur" mode = "matrix" values = "1 0 0 0 0	0 1 0 0 0	0 0 1 0 0	0 0 0 18 -7" result = "goo" > </feColorMatrix>';
            load += '      <!-- < feBlend in2 = "goo" in="SourceGraphic" result = "mix"></feBlend >-->';
            load += '    </filter>';
            load += '  </defs>';
            load += '</svg>';
            const $loadingIcon = $('<div/>').attr('id', 'loadingIcon').addClass('loading-bg').append(load);

            if (backgroundColor) {
                $loadingIcon.css('background-color', backgroundColor);
            }

            $('body').append($loadingIcon);
        }
    };

    /**
    * Loadingアニメーションを解除
    */
    hide() {
        this._count -= 1;
        if ($('#loadingIcon').length && this._count <= 0) {
            $('#loadingIcon').remove();
            // フォーカス制御イベントをoff
            $('a,button').off('focus.disabled');

            // ボタンのdisabledを解除
            if (this.$actDis && this.$actDis.length) {
                //#4343 site.tsにて、別に2重送信防止機能があるので不要!!
                //this.$actDis.prop('disabled', false);
            }
            // フォーカスを元に戻す
            if (this.$actFoc) {
                this.$actFoc.focus();
            }
            this.$actFoc = null;
            this.$actDis = null;
        }
        this._isLoading = false;
    };



    ///**
    // * Loading Animationを表示
    // * @param icon
    // * @param message
    // * @param animate
    // */
    //loadingShow(icon, message, animate) {
    //    if (this.$actFoc.length === 0) {
    //        // 現在フォーカスが与えられている要素を取得し保存する
    //        this.$actFoc = $(':focus');
    //        // エンターキーで連打が可能なため、フォーカスをblurする
    //        this.$actFoc.blur();
    //    }
    //    // このeventによって、押した場所が特定できるので、chromeやie11でしか使えないが重要
    //    const e = /firefox/g.test(window.navigator.userAgent.toLowerCase()) ? undefined : event;
    //    if (e && this.$actDis.length === 0) {
    //        // eventから現在押されたボタンを取得し保存する
    //        this.$actDis = $(e.target);
    //        // eventから現在押されたボタンをdisabledにする
    //        this.$actDis.prop('disabled', true);
    //    }
    //    this._isLoading = true;
    //    this._count += 1;

    //    //Loadingアイコンの作成
    //    if ((!$('#loadingIcon') || $('#loadingIcon').length === 0) && this._isLoading) {
    //        // フォーカスを制御
    //        $('a,button').on('focus.disabled', function (e) {
    //            // lodingアイコン中はfocusをblurする
    //            $(e.target).blur();
    //        });
    //        const _icon = icon || 'fa-compass';
    //        const _message = message || 'Loading...';
    //        const _animate = animate || 'fa-spin';
    //        // var $icon = $('<i>').addClass('fa fa-fw fa-spin loading-icon').addClass(icon || 'fa-compass'); //'fa-circle-o-notch';
    //        const $icon = $('<i>').addClass('fa fa-fw loading-icon').addClass(_icon).addClass(_animate); //'fa-circle-o-notch';
    //        const $message = $('<span>').addClass('loading-msg').text(_message);

    //        const $loadingIcon = $('<div/>').attr('id', 'loadingIcon').addClass('loading-bg').append($icon).append($message);

    //       //data保持
    //        $loadingIcon.data({ icon: _icon, message: _message, animate: _animate });
    //        $('body').append($loadingIcon);
    //    }

    //};

    ///**
    // * Loadingアニメーションを解除
    // */
    //loadingHide() {
    //    this._count -= 1;
    //    if ($('#loadingIcon').length && this._count <= 0) {
    //        $('#loadingIcon').remove();
    //        // フォーカス制御イベントをoff
    //        $('a,button').off('focus.disabled');
    //        // ボタンのdisabledを解除
    //        if (this.$actDis.length) { this.$actDis.prop('disabled', false); }
    //        // フォーカスを元に戻す
    //        this.$actFoc.focus();
    //        this.$actFoc = '';
    //        this.$actDis = '';
    //    }
    //    this._isLoading = false;
    //};

    ///**
    // * Loadingアニメーションの内容を変更
    // * @param icon
    // * @param message
    // * @param animate
    // * @deprecated
    // */
    //changeContents(icon, message, animate) {
    //    const $loadingIcon = $('#loadingIcon');
    //    if ($loadingIcon && this._isLoading) {
    //        //data取得
    //        const cache = $loadingIcon.data();
    //        const _icon = (!_.isNil(icon)) ? icon : cache.icon;
    //        const _animate = (!_.isNil(animate)) ? animate : cache.animate;
    //        const _message = (!_.isNil(message)) ? message : cache.message;
    //        $loadingIcon.find('i').removeClass(cache.icon).removeClass(cache.animate);
    //        $loadingIcon.find('i').addClass(_icon).addClass(_animate);
    //        $loadingIcon.find('span').text(_message);
    //        $loadingIcon.data({ icon: _icon, message: _message, animate: animate });
    //    }
    //};
}


//


export const loading = new Loading();
